import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Interface } from '@leverege/api-redux'
import { Flex, Button, Toast } from '@leverege/ui-elements'
import Pagination from 'react-js-pagination'
import classnames from 'classnames'
import moment from 'moment'
import { List, Loading, TextInput, YesNoDialog } from '../views'
import AddRelationshipModal from './AddRelationshipModal'
import RelationshipItem from './RelationshipItem'
import style from './style.css'

class RelationshipViewer extends React.Component {

  static TYPE = 'relationship' // StringCreator.typeName()

  static propTypes = {
    device : PropTypes.object,
    attribute : PropTypes.object,
    // blueprint : PropTypes.object,
    // name : PropTypes.string
  }

  static isToOne( att ) {
    return att?.relationshipType?.endsWith( 'ToOne' )
  }

  constructor( props ) {
    super( props )

    this.state = {
      showAddModal : false,
      showDeleteModal : false,
      toDelete : null,
      search : null,
      pagination : {
        startIndex : 0,
        perPage : 100
      }
    }

    this.reload()
    
  }

  reload = async () => {
    const { dispatch, actions, attribute } = this.props
    const { pagination, search } = this.state

    if ( RelationshipViewer.isToOne( attribute ) ) {
      dispatch( actions.get() )
    } else {
      dispatch( actions.list( { ...pagination, search } ) )
    }
  }

  onClick = () => {
    this.setState( { showAddModal : true } )
  }

  onHide = () => {
    this.setState( { showAddModal : false } )
  }

  onEvent = ( type, item ) => {
    const { history } = this.props
    if ( type === RelationshipItem.REMOVE_ITEM ) {
      this.setState( { showDeleteModal : true, toDelete : item } )
    } else if ( type === RelationshipItem.GO_TO_ITEM ) {
      history.push( `/project/${item.projectId}/system/${item.systemId}/device/${item.id}/sim` )
    } else if ( type === RelationshipItem.GO_TO_ITEM_DETAILS ) {
      history.push(
        `/project/${item.projectId}/system/${item.systemId}/device?search=${item.id}&start=0&selected=${item.id}`
      )
    }
  }

  onYesDelete = () => {
    const { toDelete } = this.state
    const { dispatch, actions } = this.props

    dispatch( actions.delete( toDelete ) )
    this.setState( { showDeleteModal : false, toDelete : null } )
  }

  onNoDelete = () => {
    this.setState( { showDeleteModal : false, toDelete : null } )
  }

  onModalEvent = ( type, item ) => {
    const { dispatch, attribute, actions } = this.props

    if ( type === 'select' ) {
      dispatch( actions.create( item ) ).then( ( res ) => {
        Toast.success( 'Relationship successfully created' )
        if ( RelationshipViewer.isToOne( attribute ) ) {
          dispatch( actions.get() )
        } else {
          dispatch( actions.list( { startIndex : 0, perPage : 100 } ) )
        }
      } ).catch( ( err ) => {
        Toast.error( [ 'Failed to create relationship', err.message ] )
      } )
      this.setState( { showAddModal : false } )
    }
  }

  onDelete = () => {
    const { interfaceVal } = this.props
    this.setState( { toDelete : interfaceVal, showDeleteModal : true } )
  }

  onGoTo = () => {
    const { interfaceVal, history } = this.props
    const item = interfaceVal?.id ? interfaceVal : null
    if ( item != null ) {
      history.push( `/project/${item.projectId}/system/${item.systemId}/device/${item.id}/sim` )
    }
  }

  onGoToDetails = () => {
    const { interfaceVal, history } = this.props
    const item = interfaceVal?.id ? interfaceVal : null
    if ( item != null ) {
      history.push(
        `/project/${item.projectId}/system/${item.systemId}/device?search=${item.id}&start=0&selected=${item.id}`
      )
    }
  }

  onPageChange = ( pageNumber ) => {
    this.setState( ( state ) => {
      const startIndex = state.pagination.perPage * ( pageNumber - 1 )
      return { pagination : { ...state.pagination, startIndex } }
    } )
  }

  componentDidUpdate( prevProps, prevState ) {
    const { pagination : { startIndex : newStartIndex, perPage : newPerPage }, search : newSearch } = this.state
    const { pagination : { startIndex : oldStartIndex, perPage : oldPerPage }, search : oldSearch } = prevState

    if ( oldStartIndex !== newStartIndex || oldPerPage !== newPerPage || oldSearch !== newSearch ) {
      this.reload()
    }
  }

  onSearchChange = ( search ) => {
    this.setState( { search } )
  }

  render() {
    const { attribute : attr, device, interfaceVal, isLoading } = this.props
    const { showAddModal, showDeleteModal, pagination, search, toDelete } = this.state

    if ( attr == null ) {
      return <div />
    }
    if ( RelationshipViewer.isToOne( attr ) ) {
      // const icon = Icons.getIcon( attr )
      let val = interfaceVal

      if ( !val ) {
        val = (
          <div className={`${style.toOneView} ${style.pairDevice}`} onClick={this.onClick}>
            <div>
              Click to Pair Device
            </div>
            <div className={style.addButton}>
              <i className="fa fa-plus" />
            </div>
          </div>
        )
      } else {
        let subtitle = (
          <div>
            <div>
              <i className={classnames( 'fa fa-clock-o', style.subtitleIcon )} /> 
              {' '}
              {moment( val.lastModified ).fromNow()}
            </div>
            <div>
              <i className={classnames( 'fa fa-microchip', style.subtitleIcon )} />
              {val && val.id}
            </div>
          </div>
        )
        if ( val.networkAliases ) {
          const network = Object.keys( val.networkAliases )[0]
          const aliasKey = Object.keys( val.networkAliases[network] )[0]
          const alias = val.networkAliases[network][aliasKey]
          subtitle = (
            <div>
              <div>
                <i className={classnames( 'fa fa-clock-o', style.subtitleIcon )} />
                {moment( val.lastModified ).fromNow()}
              </div>
              <div>
                <i className={classnames( 'fa fa-wifi', style.subtitleIcon )} />
                {`${network} | ${aliasKey} : ${alias}`}
              </div>
            </div>
          )
        }
        val = (
          <div className={style.toOneView}>
            <div>
              <div className={style.title}>
                {val.name || val.id}
              </div>
              <div className={style.subtitle}>
                {subtitle}
              </div>
            </div>
            <Flex variant="rowSCenter|rowS" className={style.right}>
              <Button variant="link" className={style.itemButton} onClick={this.onDelete}>
                <i className="fa fa-times-circle" />
              </Button>
              <Button
                title="go to device details"
                variant="link"
                className={style.itemButton}
                onClick={this.onGoToDetails}>
                <i className="fa fa-info-circle" />
              </Button>
              <Button title="go to device data" variant="link" className={style.itemButton} onClick={this.onGoTo}>
                <i className="fa fa-arrow-right" />
              </Button>
            </Flex>
          </div>
        )
      }
      return (
        <div className={style.valContainer}>
          <div className={style.header}>
            <div className={style.name}>
              {attr.name}
            </div>
          </div>
          {val}
          <AddRelationshipModal
            onEvent={this.onModalEvent}
            onHide={this.onHide}
            show={showAddModal}
            device={device}
            attribute={attr} />
          <YesNoDialog
            title="Confirm Relationship Delete"
            message="Are you sure you want to delete the relationship?"
            onYes={this.onYesDelete}
            onNo={this.onNoDelete}
            show={showDeleteModal} />
        </div>
      )
    }

    const { perPage, startIndex } = pagination
    const list = interfaceVal( pagination )

    const toView = list?.items

    let total = 0
    if ( list ) {
      total = list.total
    }

    return (
      <div className={style.left}>
        <div className={style.header}>
          <div className={style.name}>
            {attr.name}
          </div>
          <div className={style.controls}>
            <Flex variant="rowM" className={style.searchContainer}>
              <Button icon="fa fa-fw fa-refresh" variant="secondary" onClick={this.reload} />
              <TextInput
                className={style.searchBar}
                value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.onSearchChange} />
              <i className={classnames( 'fa fa-search', style.searchIcon )} />
            </Flex>
            <Button className={style.addButton} onClick={this.onClick}>
              <i className="fa fa-plus" />
            </Button>
          </div>
        </div>
        <List className={style.list}
          onEvent={this.onEvent} 
          noItemsView={<div className={style.list} />}
          items={toView}
          itemView={RelationshipItem}
          itemProps={{ showDelete : true }} />
        <Pagination
          innerClass={classnames( 'pagination', style.pagination )}
          activePage={( startIndex / perPage ) + 1}
          itemsCountPerPage={perPage}
          totalItemsCount={total}
          pageRangeDisplayed={5}
          onChange={this.onPageChange} />
        <Loading show={isLoading} message="Loading..." />
        <YesNoDialog
          title="Confirm Removal"
          // eslint-disable-next-line max-len
          message={`Are you sure you want to remove ${toDelete ? ( toDelete.name || toDelete.id ) : 'the device'} from the list?`}
          onYes={this.onYesDelete}
          onNo={this.onNoDelete}
          show={showDeleteModal} />
        <AddRelationshipModal
          onEvent={this.onModalEvent}
          onHide={this.onHide}
          show={showAddModal}
          device={device}
          attribute={attr} />
        
      </div>
    )
  }
}

export default withRouter( connect(
  ( state, props ) => {
    const { device, attribute } = props
    let actions = null
    if ( device && attribute ) {
      if ( RelationshipViewer.isToOne( attribute ) ) {
        actions = Interface.create( device?.systemId, device?.blueprintId ).obj( device?.id ).obj( attribute?.path )
      } else {
        actions = Interface.create( device?.systemId, device?.blueprintId ).obj( device?.id ).grp( attribute?.path )
      }
    }

    return {
      interfaceVal : RelationshipViewer.isToOne( attribute ) ?
        actions?.getObject( state ) :
        pagination => actions?.getList( state, pagination ),
      actions,
      isLoading : actions?.isLoading( state )
    }
  }
)( RelationshipViewer ) )
